<template>
  <b-card :header="caption">
    <div class="block-screen" v-if="loading">
      <i class="fa fa-refresh fa-spin"></i>
    </div>
    <b-modal title="Info!" class="modal-primary" v-model="emailSended" @ok="emailSended = false"
      ok-variant="primary" ok-only>
      {{emailSendedMessage}}
    </b-modal>
    <div class="d-flex justify-content-between">
      <b-button variant="default" @click="notify()" class="pull-right btn-sm">
        <i class="fa fa-envelope"></i>&nbsp; Enviar emails de registros
      </b-button>
      <b-form-group horizontal class="mb-0">
        <b-input-group style="margin-left: -9%;">
          <b-form-input v-model="filter" placeholder="Buscar..." />
        </b-input-group>
      </b-form-group>
    </div>
    <br><br>
    <b-modal title="Erro!" class="modal-danger" v-model="hasErrors" @ok="hasErrors = false" ok-variant="danger" ok-only>
      {{errorMessage}}
    </b-modal>
    <b-modal id="modal-confirmation" title="Exclusão de participante" @ok="deletePartifipant()">
      <p class="my-4">Tem certeza que deseja excluir este participante?</p>
    </b-modal>
    <b-table
      :hover="hover"
      :striped="striped"
      :bordered="bordered"
      :small="small"
      :fixed="fixed"
      class="table-responsive-sm"
      :items="items"
      :fields="fields"
      :filter="filter"
      :current-page="currentPage"
      :per-page="perPage"
      @filtered="onFiltered">
      <template slot="status" slot-scope="data">
        <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
      </template>
      <template slot="selected" slot-scope="data">
        <b-badge :variant="(data.item.selected === 'Qualificado' || data.item.selected === 'Extra') ? 'success' : 'danger'">
          {{data.item.selected}}
        </b-badge>
      </template>
      <template slot="formattedPassport" slot-scope="data">
        <b-badge :variant="data.item.formattedPassport === 'Sim' ? 'success' : 'danger'">
          {{data.item.formattedPassport}}
        </b-badge>
      </template>
      <template slot="actions" slot-scope="data" v-if="data.item.actions">
        <b-button size="sm" variant="primary" v-b-modal.modal-confirmation
          @click="deleteUserId = data.item.id" class="mr-1"  v-b-tooltip.hover title="Excluir">
          <i class="fa fa-trash"></i>
        </b-button>
        <b-button size="sm" variant="primary" @click="showModal(data.item.id)"
          v-if="data.item.actions.modal" class="mr-1">
          <i class="fa fa-folder-open"></i>
        </b-button>
        <b-button size="sm" variant="primary" @click.stop="edit(data.item.actions)"
          class="mr-1">
          <i class="fa fa-edit"></i>
        </b-button>
        <b-modal :id="'modallg' + data.item.id" size="lg" ok-only
          :title="data.item.actions.modalTitle">
          <div class="row">
            <div class="col-md-12">
              <b-card-group deck>
                <b-card header="Pessoal" class="text-center"
                  header-tag="header">
                  <p class="card-text"><strong>Nome:</strong> {{ data.item.name }}</p>
                  <p class="card-text">
                    <strong>Nascimento:</strong> {{ formatDate(data.item.dateOfBirth) }}
                  </p>
                  <p class="card-text"><strong>Idade:</strong> {{ data.item.age }}</p>
                  <p class="card-text"><strong>Parentesco:</strong> {{ data.item.type }}</p>
                  <p class="card-text"><strong>CPF</strong>: {{ data.item.cpf }}</p>
                  <p class="card-text"><strong>RG</strong>: {{ data.item.rg }}</p>
                  <p class="card-text"><strong>Validade do RG</strong>: {{ data.item.validadeRg }}</p>
                  <p class="card-text"><strong>Celular:</strong> {{ data.item.cellPhone }}</p>
                </b-card>
                <b-card header="Geral" class="text-center"
                  header-tag="header">
                  <p class="card-text"><strong>Qtd de PTC's anteriores:</strong> {{ data.item.ptcCount }}</p>
                  <p class="card-text"><strong>Restrição alimentar:</strong> {{ data.item.food }}</p>
                  <p class="card-text"><strong>Necessidades especiais:</strong> {{ data.item.specialNeeds }}</p>
                  <p class="card-text"><strong>Observação:</strong> {{ data.item.observation }}</p>
                </b-card>
              </b-card-group>
            </div>
          </div>
        </b-modal>
      </template>
    </b-table>
    <nav>
      <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" hide-goto-end-buttons/>
    </nav>
  </b-card>
</template>

<script>
  import * as Helper from './../methods/helpers';

  export default {
    name: 'table',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      },
      modalTitle: '',
      items: '',
      fields: {
        type: Array,
        default: () => []
      },
      excelFields: Object,
      excelData: Array,
      excelName: String
    },
    data: () => {
      return {
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        filter: null,
        pending: false,
        json_fields: {},
        json_data: [],
        json_meta: [
          [{
            key: 'charset',
            value: 'utf-8'
          }]
        ],
        deleteUserId: null,
        errorMessage: null,
        hasErrors: false,
        emailSended: false,
        emailSendedMessage: '',
        loading: false
      }
    },
    methods: {
      showModal (modal) {
        this.$root.$emit('bv::show::modal', `modallg${modal}`)
      },
      onFiltered (filteredItems) {
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      getBadge (status) {
        return status === 'Concluído' ? 'success'
          : status === 'Inativo' ? 'secondary'
            : status === 'Pendente' ? 'warning'
              : status === 'Banido' ? 'danger' : 'primary'
      },
      getRowCount (items) {
        return items.length
      },
      edit (action) {
        if (action !== undefined && action.id !== undefined) {
          if (action.edit !== undefined && action.edit === 'order') {
            this.$parent.$parent.editOrder = true
            this.$parent.$parent.currentOrder = action.id
          } else {
            this.$router.push({name: action.route, params: {id: action.id}})
          }
        }
      },
      formatDate (date) {
        if (date !== undefined && date !== null) {
          return Helper.formatDate(date)
        }
        return ''
      },
      deletePartifipant() {
        this.loading = true;
        this.$http.delete(`participants/${this.deleteUserId}`)
        .then((response) => {
          this.loading = false;
          if (response.data.code === 200) {
            this.$router.go();
          } else {
            this.hasErrors = true;
            this.errorMessage = response.data.msg;
          }
        })
        .catch((error) => {
          console.error(error)
          this.errorMessage = response.data.msg;
          this.hasErrors = true;
          this.loading = false;
        });
      },
      notify() {
        this.loading = true;
        let id = this.items.map((elm) => elm.id);
        this.$http.post(`users/notify`, {id}).then(() => {
          this.loading = false;
          this.emailSended = true;
          this.emailSendedMessage = 'Emails enviados com sucesso!';
        })
        .catch(error => {
          console.error(error)
          this.loading = false
        })
      }
    },
    mounted () {
      setTimeout(() => {
        this.json_fields = this.excelFields
        this.json_data = this.excelData
      }, 500)
    },
    watch: {
      pending: function (value) {
        this.$parent.getUsers(value)
      },
      excelData: function (value) {
        this.json_data = this.$parent.items
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Table.vue